import { Component, inject, Inject, OnInit, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DOCUMENT, NgClass } from '@angular/common';
import { ButtonModule } from '@/modules/shared/button/button.module';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs';
import { AvailabilityErrorService } from '../availability-error/availability-error.service';

@Component({
	selector: 'app-contact-form',
	templateUrl: './contact-form.component.html',
	styleUrls: ['./contact-form.component.css'],
	standalone: true,
	imports: [ReactiveFormsModule, NgClass, ButtonModule],
})
export class ContactFormComponent implements OnInit {
	formSend = output<void>();

	constructor(@Inject(DOCUMENT) private readonly document: Document) {}

	contactForm: FormGroup = new FormGroup({
		firstName: new FormControl('', [Validators.required]),
		lastName: new FormControl(''),
		email: new FormControl('', [Validators.email]),
		phone: new FormControl('', [Validators.minLength(9), Validators.maxLength(12), Validators.required]),
		message: new FormControl(''),
		consentCheck: new FormControl(false, [Validators.requiredTrue]),
	});
	showError = false;

	private readonly httpClient = inject(HttpClient);
	private readonly availabilityErrorService = inject(AvailabilityErrorService);

	ngOnInit(): void {
		if (this.document.querySelector('.offer-detail-page') || this.document.querySelector('.reservation-form'))
			this.document.querySelector('app-contact-form')?.classList.add('zoom-contact');
	}

	protected submitForm(): void {
		this.contactForm.markAllAsTouched();
		if (this.contactForm.invalid) {
			this.showError = true;
			setTimeout(() => (this.showError = false), 3000);
			return;
		}
		let consentMessage = '';
		if (this.contactForm.get('consentCheck')?.valid)
			consentMessage = 'Klient wyraził zgodę na przetwarzanie danych osobowych';

		const formPayload = {
			firstName: this.getFormValue('firstName'),
			lastName: this.getFormValue('lastName'),
			mail: this.getFormValue('email'),
			phone: this.getFormValue('phone'),
			note: `${this.contactForm.get('message')?.value}<br>${consentMessage}`,
		};

		this.httpClient
			// Contact form endpoint exposed via AWS API Gateway -> Lambda.
			// x-site-secret is used by the backend to authorize/validate requests (simple shared secret).
			.post('https://lmeeze7jga.execute-api.eu-central-1.amazonaws.com/contact', formPayload)
			.pipe(
				catchError((err) => {
					this.availabilityErrorService.showAvailabilityError('Występił błąd podczas wysyłania formularza.');
					throw new Error(err.statusText);
				}),
			)
			.subscribe(() => this.formSend.emit());
	}

	private getFormValue(name: string): string {
		return this.contactForm.get(name)?.value.replace(/\s+/g, '');
	}
}
